module.exports = __webpack_public_path__ + "static/media/logoSTI.9d452dff.png";